export const PUBLISHER_NAME = 'Egebit Limited'
export const PUBLISHER_URL = 'https://egebit.com/'
export const APP_STORE_URL = 'https://salestaxcalculator.go.link/o6868'
export const GOOGLE_PLAY_URL = 'https://salestaxcalculator.go.link/50AOQ'

// One editorial selection for both the initial HTML and the interactive page.
export const HOME_GUIDE_SLUGS = ['us-sales-tax-guide', 'sales-tax-nexus-determination', 'saas-sales-tax-customer-location']
export const HOME_BLOG_SLUGS = ['shipping-tax-mixed-cart', 'zero-sales-tax-return', 'ioss-for-us-sellers']
export const APP_SCREEN = {
  src: '/assets/app-calculator-screen-480.webp',
  srcSet: '/assets/app-calculator-screen-240.webp 240w, /assets/app-calculator-screen-480.webp 480w, /assets/app-calculator-screen-720.webp 720w',
  sizes: '(max-width: 680px) 222px, 247px',
  width: 1179, height: 2556,
  alt: 'Sales Tax Calculator app showing a tax breakdown and total amount.',
}
